module.exports = __webpack_public_path__ + "img/69179b9.png";